import { DASHBOARD } from "../Dispatchers";
import { dashboard } from "../service/UserService"

export const fetchDashboardAction=()=>{
    return (dispatch)=>{
        dashboard().then((response)=>{
            dispatch({type:DASHBOARD, payload:response.data})
        }).catch((error)=>{
            console.log(error)
        })
    }
}